const MAP = {
  awaiting_quote: ["Awaiting rate confirmation", "bg-violet-50 text-violet-800 border-violet-300"],
  pending_payment: ["Awaiting payment", "bg-amber-50 text-amber-800 border-amber-300"],
  pending_verification: ["Payment pending verification", "bg-sky-50 text-sky-800 border-sky-300"],
  paid: ["Paid", "bg-emerald-50 text-emerald-800 border-emerald-300"],
  failed: ["Payment not received", "bg-red-50 text-red-700 border-red-300"],
  refunded: ["Refunded", "bg-stone-100 text-stone-700 border-stone-300"],
  expired: ["Hold expired", "bg-stone-100 text-stone-600 border-stone-300"],
  pending: ["Pending", "bg-amber-50 text-amber-800 border-amber-300"],
  confirmed: ["Confirmed", "bg-emerald-50 text-emerald-800 border-emerald-300"],
  cancelled: ["Cancelled", "bg-red-50 text-red-700 border-red-300"],
};

export default function StatusBadge({ status, testId }) {
  const [label, cls] = MAP[status] || [status, "bg-stone-100 text-stone-700 border-stone-300"];
  return <span data-testid={testId} className={`inline-flex items-center border px-3 py-1 text-[11px] uppercase tracking-[0.15em] font-medium ${cls}`}>{label}</span>;
}
